import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class CotizationService {
  constructor(private restService: RestService) {}

  search(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('cotization/search', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('cotization/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('cotization/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('cotization/save', data);
  }

  updateSave(data: any) {
    return this.restService.save('cotization/update/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('cotization/update', val_id, data);
  }

  updateVideo(val_id: number, data: any) {
    return this.restService.update('cotization/update/video', val_id, data);
  }

  saveImage(data: any) {
    return this.restService.save('cotization/save/image', data);
  }

  delete(val_id: number) {
    return this.restService.delete('cotization/delete', val_id);
  }
}